/**
 * @desc 更新
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.CertificationDocumentAddAndModifyRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/certificationDocument/modify`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
